import firebase from 'firebase'
import React from 'react'

function AdditionList({ handleRemoveAddition, additions}) {
  return (
    <div>
      {additions.length > 0 && (
        <div className="date-section">
            <h5>Additional Availability</h5>
            {additions.map((item) => (
            <div key={item.id} className="date-item available">
                {`${item.range[0] instanceof firebase.firestore.Timestamp ?  item.range[0].toDate().toLocaleDateString() : item.range[0].toLocaleDateString()}
                 - 
                ${item.range[1] instanceof firebase.firestore.Timestamp ?  item.range[1].toDate().toLocaleDateString() : item.range[1].toLocaleDateString()}`}
                <button
                    className="btn-remove"
                    onClick={() => handleRemoveAddition(item)}
                >
                ×
                </button>
            </div>
            ))}
        </div>
        )}
    </div>
  )
}

export default AdditionList
